
if (!window.Eurus) window.Eurus = {};
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('custom-horizontal-scroll.js')) {
  window.Eurus.loadedScript.add('custom-horizontal-scroll.js');

  const registerHorizontalScroll = () => {
    Alpine.data('xHorizontalScroll', () => ({
      active: 1,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      container: null,
      canScrollLeft: false,
      canScrollRight: false,
      showArrows: false,
      resizeObserver: null,
      animationFrameId: null,
      cleanupEvents: [],

      init() {
        this.$nextTick(() => {
          this.container = this.$el.querySelector('.scrollable-container');
          if (!this.container) return;

          this.checkArrowsVisibility();

          if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(() => {
              this.scheduleArrowsUpdate();
            });

            this.resizeObserver.observe(this.container);

            Array.from(this.container.children).forEach(child => {
              this.resizeObserver.observe(child);
            });
          }

          this.addEvent(window, 'resize', () => {
            this.scheduleArrowsUpdate();
          });

          this.addEvent(this.container, 'scroll', () => {
            this.scheduleArrowsUpdate();
          }, { passive: true });

          this.addEvent(this.container, 'mousedown', event => {
            if (event.button !== 0) return;

            // 不干扰加入购物车等交互元素
            if (event.target.closest(
              'a, button, input, select, textarea, [contenteditable="true"]'
            )) return;

            this.isDragging = true;
            this.startX = event.pageX;
            this.scrollLeft = this.container.scrollLeft;

            this.container.style.cursor = 'grabbing';
            this.container.style.userSelect = 'none';
          });

          this.addEvent(window, 'mousemove', event => {
            if (!this.isDragging) return;

            event.preventDefault();

            const distance = (event.pageX - this.startX) * 2;
            this.container.scrollLeft = this.scrollLeft - distance;
          });

          this.addEvent(window, 'mouseup', () => {
            this.stopDragging();
          });

          this.addEvent(window, 'blur', () => {
            this.stopDragging();
          });

          this.container.style.webkitOverflowScrolling = 'touch';
          this.scheduleArrowsUpdate();
        });
      },

      addEvent(target, eventName, handler, options) {
        target.addEventListener(eventName, handler, options);

        this.cleanupEvents.push(() => {
          target.removeEventListener(eventName, handler, options);
        });
      },

      stopDragging() {
        if (!this.isDragging) return;

        this.isDragging = false;

        if (this.container) {
          this.container.style.removeProperty('cursor');
          this.container.style.removeProperty('user-select');
        }

        this.scheduleArrowsUpdate();
      },

      scheduleArrowsUpdate() {
        if (this.animationFrameId !== null) return;

        this.animationFrameId = requestAnimationFrame(() => {
          this.animationFrameId = null;
          this.checkArrowsVisibility();
        });
      },

      checkArrowsVisibility() {
        if (!this.container) return;

        const containerWidth = this.container.clientWidth;
        const contentWidth = this.container.scrollWidth;

        this.showArrows = contentWidth > containerWidth + 1;
        this.updateArrowsState(containerWidth, contentWidth);
      },

      updateArrowsState(containerWidth, contentWidth) {
        if (!this.container) return;

        if (!this.showArrows) {
          this.canScrollLeft = false;
          this.canScrollRight = false;
          return;
        }

        containerWidth ??= this.container.clientWidth;
        contentWidth ??= this.container.scrollWidth;

        const current = this.container.scrollLeft;

        this.canScrollLeft = current > 1;
        this.canScrollRight =
          current < contentWidth - containerWidth - 1;
      },

      scrollLeftFn() {
        if (!this.container || !this.canScrollLeft) return;

        this.container.scrollBy({
          left: -250,
          behavior: 'smooth'
        });
      },

      scrollRightFn() {
        if (!this.container || !this.canScrollRight) return;

        this.container.scrollBy({
          left: 250,
          behavior: 'smooth'
        });
      },

      destroy() {
        this.stopDragging();

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }

        if (this.animationFrameId !== null) {
          cancelAnimationFrame(this.animationFrameId);
          this.animationFrameId = null;
        }

        this.cleanupEvents.forEach(cleanup => cleanup());
        this.cleanupEvents = [];
      }
    }));
  };

  if (window.Alpine) {
    registerHorizontalScroll();
  } else {
    document.addEventListener(
      'alpine:init',
      registerHorizontalScroll,
      { once: true }
    );
  }
}
